import { render, staticRenderFns } from "./PopuSubTable.vue?vue&type=template&id=163fd4d4&scoped=true&"
import script from "./PopuSubTable.vue?vue&type=script&lang=js&"
export * from "./PopuSubTable.vue?vue&type=script&lang=js&"
import style0 from "./PopuSubTable.vue?vue&type=style&index=0&id=163fd4d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fd4d4",
  null
  
)

export default component.exports